(ns iris.styles.search
  (:require
;;    [herb.core :refer [<class <id]]
  ;;  [garden.units :refer [px]]
   [shadow.css :refer [css]]
   ))



(def $navbar
  (css
   {:--iris-admin-top "25px"
    :--iris-nav-height "50px"
    :--iris-nav-pad "15px"
    :--iris-nav-gap "8px"
    :--iris-toggle-width "0px"
    :--iris-alert-panel-right "calc(var(--iris-nav-pad) * -1)"
    :align-items "center"
    :background "navy"
    :box-shadow "0 1px 4px rgba(0,0,0,0.22)"
    :box-sizing "border-box"
    :color "#fff"
    :display "flex"
    :gap "var(--iris-nav-gap)"
    :height "var(--iris-nav-height)"
    :left "0"
    :margin-bottom "20px"
    :overflow "visible"
    :padding "0 15px"
    :position "sticky"
    :right "0"
    :top "var(--iris-admin-top)"
    :z-index 10000}
   ["&.iris-navbar-scrolled"
    {:--iris-nav-height "26px"
     :--iris-nav-pad "4px"
     :padding "0 4px"}]
   ["& .iris-navbar-brand"
    {:align-items "center"
     :color "#fff !important"
     :display "inline-flex"
     :font-size "18px"
     :height "100%"
     :justify-content "center"
     :line-height "1"
     :text-decoration "none !important"}]
   ["&.iris-navbar-scrolled .iris-navbar-brand"
    {:font-size "13px"
     :width "26px"}]
   ["& .iris-navbar-side-panel-toggle"
    {:align-items "center"
     :background "navy"
     :border "1px solid rgba(255,255,255,0.45)"
     :border-radius "3px"
     :color "#fff"
     :display "inline-flex"
     :flex "0 0 auto"
     :height "32px"
     :justify-content "center"
     :margin "0"
     :overflow "hidden"
     :padding "0"
     :position "relative"
     :width "32px"}]
   ["&.iris-navbar-scrolled .iris-navbar-side-panel-toggle"
    {:border-radius "2px"
     :height "22px"
     :width "26px"}]
   ["& .iris-navbar-side-panel-mark"
    {:background "#fff"
     :display "block"
     :height "100%"
     :position "absolute"
     :top "0"
     :width "50%"}]
   ["& .iris-navbar-side-panel-toggle-collapsed .iris-navbar-side-panel-mark"
    {:left "0"}]
   ["& .iris-navbar-side-panel-toggle-open .iris-navbar-side-panel-mark"
    {:right "0"}]
   ["& .iris-navbar-side-panel-arrow"
    {:border "solid navy"
     :border-width "0 2px 2px 0"
     :display "block"
     :height "8px"
     :position "absolute"
     :top "11px"
     :width "8px"}]
   ["& .iris-navbar-side-panel-toggle-collapsed .iris-navbar-side-panel-arrow"
    {:left "2px"
     :transform "rotate(-45deg)"}]
   ["& .iris-navbar-side-panel-toggle-open .iris-navbar-side-panel-arrow"
    {:left "20px"
     :transform "rotate(135deg)"}]
   ["&.iris-navbar-scrolled .iris-navbar-side-panel-arrow"
    {:border-width "0 2px 2px 0"
     :height "6px"
     :top "7px"
     :width "6px"}]
   ["&.iris-navbar-scrolled .iris-navbar-side-panel-toggle-collapsed .iris-navbar-side-panel-arrow"
    {:left "2px"}]
   ["&.iris-navbar-scrolled .iris-navbar-side-panel-toggle-open .iris-navbar-side-panel-arrow"
    {:left "16px"}]
   ["& .iris-navbar-toggle"
    {:align-items "center"
     :background "navy"
     :border "1px solid rgba(255,255,255,0.45)"
     :border-radius "3px"
     :color "#fff"
     :display "none"
     :height "32px"
     :justify-content "center"
     :margin "0"
     :padding "0 8px"
     :width "38px"}]
   ["& .iris-navbar-toggle-bar"
    {:background "#fff"
     :display "block"
     :height "2px"
     :margin "2px 0"
     :width "18px"}]
   ["& .navbar-mini-links"
    {:align-items "center"
     :display "flex"
     :gap "4px"
     :height "100%"
     :min-width "0"
     :overflow-x "auto"
     :overflow-y "hidden"
     :scrollbar-width "none"}]
   ["& .navbar-mini-links::-webkit-scrollbar"
    {:display "none"}]
   ["& .navbar-mini-link"
    {:align-items "center"
     :color "#fff !important"
     :display "inline-flex"
     :font-size "14px"
     :gap "5px"
     :height "100%"
     :justify-content "center"
     :line-height "1"
     :padding "0 10px"
     :text-decoration "none !important"
     :white-space "nowrap"
     :width "auto"}]
   ["& .navbar-mini-link i"
    {:display "inline-block"
     :font-size "13px"
     :line-height "1"
     :top "0"}]
   ["& .navbar-mini-label"
    {:display "inline"
     :font-size "14px"
     :line-height "1"}]
   ["&.iris-navbar-scrolled .navbar-mini-links"
    {:gap "2px"}]
   ["&.iris-navbar-scrolled .navbar-mini-link"
    {:font-size "12px"
     :gap "3px"
     :height "26px"
     :padding "0 6px"}]
   ["&.iris-navbar-scrolled .navbar-mini-link i"
    {:font-size "11px"}]
   ["&.iris-navbar-scrolled .navbar-mini-label"
    {:font-size "11px"}]
   ["& .navbar-mini-link:hover, & .navbar-mini-link:focus"
    {:color "#fec761 !important"
     :outline "none"}]
   ["& .navbar-mini-actions"
    {:align-items "center"
     :display "flex"
     :height "100%"
     :margin-left "auto"
     :position "relative"}]
   ["& .navbar-mini-actions > div"
    {:align-items "center"
     :display "flex"
     :height "100%"
     :position "relative"}]
   ["& .navbar-mini-actions button.btn"
    {:align-items "center"
     :background-color "navy !important"
     :border "1px solid rgba(255,255,255,0.35) !important"
     :border-radius "3px !important"
     :box-sizing "border-box !important"
     :display "inline-flex"
     :float "none !important"
     :font-size "12px !important"
     :height "32px !important"
     :justify-content "center"
     :line-height "1 !important"
     :margin "0 !important"
     :min-height "0 !important"
     :padding "0 !important"
     :width "32px !important"}]
   ["& .navbar-mini-actions button.btn:focus, & .navbar-mini-actions button.btn:active"
    {:box-shadow "none !important"
     :outline "none !important"}]
   ["&.iris-navbar-scrolled .navbar-mini-actions button.btn"
    {:height "22px !important"
     :width "26px !important"}]
   ["& .navbar-mini-actions button.btn .bi"
    {:display "inline-block"
     :font-size "14px"
     :height "14px"
     :line-height "1"
     :width "14px"}]
   ["&.iris-navbar-scrolled .navbar-mini-actions button.btn .bi"
    {:font-size "13px"
     :height "13px"
     :width "13px"}]
   ["& .navbar-mini-actions .badge"
    {:font-size "10px !important"
     :line-height "1 !important"
     :min-width "12px !important"
     :padding "2px 5px !important"
     :right "-8px !important"
     :top "-6px !important"
     :z-index "1 !important"}]
   ["&.iris-navbar-scrolled .navbar-mini-actions .badge"
    {:border-radius "999px !important"
     :font-size "0 !important"
     :height "7px !important"
     :line-height "0 !important"
     :min-width "0 !important"
     :padding "0 !important"
     :right "-1px !important"
     :top "-1px !important"
     :width "7px !important"}]
   ["& .navbar-mini-actions > div > div:last-child"
    {:max-height "calc(100vh - 54px)"
     :right "var(--iris-alert-panel-right) !important"
     :top "100% !important"
     :width "min(385px, calc(100vw - 8px))"}]
   ["@media (max-width: 767px)"
    {:--iris-admin-top "50px"
     :--iris-nav-height "42px"
     :--iris-nav-pad "8px"
     :--iris-nav-gap "8px"
     :--iris-toggle-width "30px"
     :--iris-alert-panel-right "calc((var(--iris-nav-pad) + var(--iris-toggle-width) + var(--iris-nav-gap)) * -1)"
     :padding "0 8px"}
    ["&.iris-navbar-scrolled"
     {:--iris-nav-height "26px"
      :--iris-nav-pad "4px"
      :--iris-nav-gap "4px"
      :--iris-toggle-width "24px"
      :padding "0 4px"}]
    ["& .iris-navbar-brand"
     {:font-size "16px"
      :width "28px"}]
    ["& .iris-navbar-side-panel-toggle"
     {:display "inline-flex"
      :flex "0 0 auto"
      :height "30px"
      :order "1"
      :width "30px"}]
    ["&.iris-navbar-scrolled .iris-navbar-side-panel-toggle"
     {:border-radius "2px"
      :height "18px"
      :width "24px"}]
    ["&.iris-navbar-scrolled .iris-navbar-side-panel-arrow"
     {:height "5px"
      :top "6px"
      :width "5px"}]
    ["&.iris-navbar-scrolled .iris-navbar-side-panel-toggle-collapsed .iris-navbar-side-panel-arrow"
     {:left "2px"}]
    ["&.iris-navbar-scrolled .iris-navbar-side-panel-toggle-open .iris-navbar-side-panel-arrow"
     {:left "15px"}]
    ["& .iris-navbar-toggle"
     {:display "inline-flex"
      :flex "0 0 auto"
      :flex-direction "column"
      :height "30px"
      :order "3"
      :padding "0"
      :width "30px"}]
    ["&.iris-navbar-scrolled .iris-navbar-toggle"
     {:border-radius "2px"
      :height "18px"
      :padding "0"
      :width "24px"}]
    ["&.iris-navbar-scrolled .iris-navbar-toggle-bar"
     {:height "1px"
      :margin "1.5px 0"
      :width "13px"}]
    ["&.iris-navbar-scrolled .iris-navbar-brand"
     {:font-size "13px"
      :width "22px"}]
    ["& .navbar-mini-links"
     {:align-items "stretch"
      :background "navy"
      :border-top "1px solid rgba(255,255,255,0.25)"
      :box-shadow "0 4px 8px rgba(0,0,0,0.24)"
      :display "none"
      :flex-direction "column"
      :gap "0"
      :height "auto"
      :left "0"
      :max-height "calc(100dvh - 92px)"
      :overflow-y "auto"
      :padding "4px 0"
      :position "absolute"
      :right "0"
      :top "100%"}]
    ["&.iris-navbar-menu-open .navbar-mini-links"
     {:display "flex"}]
    ["& .navbar-mini-link, &.iris-navbar-scrolled .navbar-mini-link"
     {:font-size "14px"
      :gap "8px"
      :height "38px"
      :justify-content "flex-start"
      :padding "0 14px"
      :width "100%"}]
    ["& .navbar-mini-label, &.iris-navbar-scrolled .navbar-mini-label"
     {:display "inline"
      :font-size "14px"}]
    ["& .navbar-mini-actions"
     {:flex "0 0 auto"
      :margin-left "auto"
      :order "2"}]
    ["&.iris-navbar-mobile:not(.iris-navbar-scrolled) .navbar-mini-actions button.btn"
     {:height "30px !important"
      :width "30px !important"}]
    ["&.iris-navbar-mobile.iris-navbar-scrolled .navbar-mini-actions button.btn"
     {:border-radius "2px !important"
      :flex "0 0 24px !important"
      :height "18px !important"
      :max-height "18px !important"
      :min-height "0 !important"
      :min-width "0 !important"
      :width "24px !important"}]
    ["&.iris-navbar-mobile.iris-navbar-scrolled .navbar-mini-actions button.btn .bi"
     {:font-size "12px"
      :height "12px"
      :width "12px"}]
    ["&.iris-navbar-mobile.iris-navbar-scrolled .navbar-mini-actions .badge"
     {:right "-1px !important"
      :top "-1px !important"}]
    ["& .navbar-mini-actions > div > div:last-child"
     {:position "absolute"
      :right "var(--iris-alert-panel-right) !important"
      :top "100% !important"}]]
   ["@media (max-width: 640px) and (orientation: portrait)"
    ["&.iris-navbar-mobile .navbar-mini-actions > div > div:last-child"
     {:box-sizing "border-box"
      :left "0 !important"
      :max-height "calc(100dvh - var(--iris-admin-top) - var(--iris-nav-height))"
      :position "fixed"
      :right "0 !important"
      :top "calc(var(--iris-admin-top) + var(--iris-nav-height)) !important"
      :width "100vw"}]]))

(def $search-wrap
  (css
   [:md :text-right :pr-2.5]
   {:background "var(--iris-search-bg)"
    :border-bottom "1px solid var(--iris-border)"
    :color "var(--iris-text)"
    :box-shadow "0 2px 5px rgba(0,0,0,0.18)"
    :z-index 10001}))

(def $navbar-search
  (css
   {:left "0"
    :position "fixed"
    :right "0"
    :top "75px"
    :z-index 10001}
   ["&.iris-search-scrolled"
    {:top "51px"}]
   ["@media (max-width: 767px)"
    {:top "92px"}
    ["&.iris-search-scrolled"
     {:top "76px"}]]))

(def $search-bar
  (css :p-1))

(def $search-tabs
  (css {:margin "20px 0 25px"}))

(def $search-form-wrap
  (css {:margin "30px 0 50px"}))

(def $header-search-page
  (css
   {:width "auto"}
   ["@media (min-width: 992px)" {:width "970px"}]
   ["@media (min-width: 1200px)" {:width "1170px"}]))

(def $header-search-form
  (css
   {:display "flex"
    :align-items "flex-start"
    :gap "5px"
    :flex-wrap "wrap"}))

(def $header-search-query-input
  (css
   {:flex "1 1 320px"
    :min-width "180px"}))

(def $post-search-form-controls
  (css
   {:display "flex"
    :align-items "flex-start"
    :gap "5px"
    :flex-wrap "wrap"
    :margin-bottom "10px"}))

(def $post-search-query-input
  (css
   {:flex "1 1 320px"
    :min-width "180px"}))

(def $header-search-column-switch
  (css
   {:position "relative"
    :display "inline-block"
    :margin-left "auto"}))

(def $header-search-column-switch-button
  (css {:white-space "nowrap"}))

(def $header-search-column-panel
  (css
   {:position "absolute"
    :right "0"
    :top "35px"
    :z-index 1000
    :width "640px"
    :max-width "calc(100vw - 30px)"
    :padding "10px"
    :text-align "left"}))

(def $header-search-column-picker
  (css
   {:display "grid"
    :gap "4px 12px"
    :grid-template-columns "repeat(auto-fit, minmax(150px, 1fr))"}))

(def $header-search-column-picker-button
  (css
   {:text-align "left"
    :white-space "nowrap"}))

(def $header-search-results-workspace
  (css
   {:width "100%"
    :max-width "100%"}))

(def $header-search-results-head
  (css
   {:max-width "748px"
    :margin-left "auto"
    :margin-right "auto"}))

(def $search-limit-controls
  (css {:margin-top "12px"
        :margin-bottom "36px"}))

(def $header-search-table-wrap
  (css
   {:width "100%"
    :max-width "100%"
    :overflow-x "auto"
    :position "relative"
    :scrollbar-width "thin"
    :scrollbar-color "#c8c8c8 transparent"}
   ["&::-webkit-scrollbar" {:height "8px"}]
   ["&::-webkit-scrollbar-track" {:background "transparent"}]
   ["&::-webkit-scrollbar-thumb" {:background "#c8c8c8"
                                  :border-radius "999px"}]
   ["&::-webkit-scrollbar-thumb:hover" {:background "#a8a8a8"}]
   ["@media (pointer: coarse)" {:scrollbar-width "none"
                                :-ms-overflow-style "none"}
    ["&::-webkit-scrollbar" {:display "none"}]]))

(def $header-search-table
  (css
   {:width "max-content"
    :min-width "100%"}
   ["& > thead > tr > th:last-child" {:background-color "var(--iris-header-search-actions-header-bg)"}]
   ["& > tbody > tr:nth-of-type(odd) > td:last-child" {:background-color "var(--iris-header-search-actions-row-alt-bg)"}]
   ["& > tbody > tr:nth-of-type(even) > td:last-child" {:background-color "var(--iris-header-search-actions-row-bg)"}]
   ["& > tbody > tr:hover > td" {:background-color "var(--iris-table-hover)"}]
   ["& > tbody > tr:hover > td:last-child" {:background-color "var(--iris-table-hover)"}]))

(def $header-search-actions-group
  (css
   {:display "inline-table"
    :white-space "nowrap"}
   ["& > .btn" {:display "table-cell"
                :float "none"}]))

(def $header-search-actions-cell
  (css
   {:min-width "130px"
    :white-space "nowrap"
    :text-align "right"
    :position "sticky"
    :right "0"
    :z-index 2}
   ["&::before" {:content "\"\""
                 :position "absolute"
                 :top "0"
                 :bottom "0"
                 :left "0"
                 :width "2px"
                 :background "var(--iris-border)"
                 :pointer-events "none"}]))

(def $search-btn
  (css [:md {:margin "0 5px"}]
       ["&:hover, &:focus" {:background-color "var(--iris-search-btn-hover-bg)"
                             :border-color "var(--iris-search-btn-hover-border)"
                             :color "var(--iris-search-btn-hover-text) !important"}]
       {:color "var(--iris-search-btn-text)"
        :background-color "var(--iris-search-btn-bg)"
        :border-color "var(--iris-search-btn-border)"
        :margin "5px 5px 0 0"}))

(def $search-help-icon
  (css
   {:color "var(--iris-text)"
    :font-size "1.5rem"}))

(def $input-label
  (css {:color "var(--iris-text)"
        :font-weight "normal"
        :margin "0 5px 0 5px"}
       ["@media (min-width: 360px)" {:margin "0 10px 0 10px"}]))

(def $input-wrap-dev
  (css
   :inline-block
   ["@media (max-width: 430px)" :w-full]
   {:line-height "4.5rem"}))


(def $input-wrap-span
  (css
   {:border "1px solid var(--iris-input-border)"
    :padding "6px"
    :margin "5px"
    :border-radius "5px"
    :vertical-align "middle"}))

(def $index-input-wrap-span
  (let [$index-ext (css ["@media (max-width: 430px)" {:float "right"
                                                      :margin "auto"
                                                      :line-height "20px"}] )]
    [$input-wrap-span $index-ext]))


(def $order-input-wrap-span
  (let [$order-ext (css ["@media (max-width: 430px)" {:float "left"
                                                      :margin "auto"
                                                      :line-height "20px"}])]
    [$input-wrap-span $order-ext]))




(defn $search-help-div [state]
  (let [$display (if (true? state) (css :block) (css :hidden))
        $base (css
               :absolute
               :right-0
               :w-full
               :bg-black
               :text-left
               [:md {:width "320px"
                     :top "45px"}]
               {:top "80px"
                :color "#fff"
                :padding "5px 10px"}
               ["& .searchFields" {:width "100%"}])]
    [$base $display]))


(def $search-help-h4
  (css
   ;;  :text-base ;; 1rem becomes only 10px, probably inheritance issue, set to 16px for now
    :font-bold
   {:font-size "16px"}))

(def $search-help-td
  (css
   :w-1of2)
  ;; {:width "50%"}
  )




;; works but no need for this - hidden state never gets activated, js just removes the component entirely
;; (defn $search-bar [state]
;;   (let [$base (css {:padding "5px"})
;;         $display (if (true? state)
;;                    (css :block)
;;                    (css :hidden))]
;;     [$base $display]))

;; TODO: navbar should not be in search namespace... perhaps the other way around...
;; also admin top bar is now a webcomponent so any css referencing it here should be removed.
;; (defn navbar []
;;   ^{:media {{:screen :only :min-width "768px"} {:top "-25px"}}}
;;   {:position "sticky"
;;    :top 0
;;    :z-index 10000})

;; not in use it seems
;; (defn admin-top-bar []
;;   {:z-index 1030
;;    :height "25px"
;;    :width "100%"
;;    :padding "3px 10px"
;;    :position "relative" ;; need this to make this bar go over logs panel
;;    })

;; not in use it seems
;; (defn service-info []
;;   {:float "right"
;;    :display "inline-block"
;;    :margin-right "15px"})

;; (defn search-wrap []
;;   ^{:media {{:screen :only :min-width "768px"} {:text-align "right"
;;                                                 :padding-right "10px"}}}
;;   {:background "#f5f5f5"
;;    :z-index 1031
;;    :position "relative"})



;; not in use it seems
;; (defn search-icon []
;;   {
;;   ;;  :position "fixed"
;;    :position "absolute"
;;    :right "15px"
;;   ;;  :top "5px"
;;   ;;  :top "-70px"
;;    :color "black"
;;    :cursor "pointer"
;;    :line-height "22px"})


;; (defn search-bar [state]
;;   (let [display (if (true? state) "block" "none")]
;;     {:display display
;;      :padding "5px"}))


;; (defn search-btn []
;;   ^{:pseudo {:hover {:background-color "#ccc"}}
;;     :media {{:screen :only :min-width "768px"} {:margin "0 5px"}}}
;;   {:margin "5px 5px 0 0"
;;    :color "#333"
;;    :background-color "#ddd"
;;    :border-color "#ddd"})


;; (defn search-help-icon []
;;   {:color "#333"
;;    :font-size "1.5rem"})


;; (defn input-label []
;;   ^{:media {{:screen :only :min-width "360px"} {:margin "0 10px 0 10px"}}}
;;   {:color "#333"
;;    :font-weight "normal"
;;    :margin "0 5px 0 5px"})


;; (defn input-wrap-dev []
;;   ^{:media {{:screen :only :max-width "430px"} {:width "100%"}}}
;;   {:display "inline-block"
;;    :line-height "4.5rem"})


;; (defn input-wrap-span []
;;   {:border "1px #9999999e solid"
;;    :padding "6px"
;;    :margin "5px"
;;    :border-radius "5px"
;;    :vertical-align "middle"})


;; (defn index-input-wrap-span []
;;   ^{:extend input-wrap-span}
;;   ^{:media {{:screen :only :max-width "430px"} {:float "right"
;;                                                  :margin "auto"
;;                                                  :line-height "20px"}}}
;;   {})


;; (defn order-input-wrap-span []
;;   ^{:extend input-wrap-span}
;;   ^{:media {{:screen :only :max-width "430px"} {:float "left"
;;                                                  :margin "auto"
;;                                                  :line-height "20px"}}}
;;   {})


;; (defn search-help-div [state]
;;   (let [display (if (true? state) "block" "none")]
;;       ^{:media {{:screen :only :min-width "768px"} {:width "400px"
;;                                                 :top "45px"}}}
;;     {:display display
;;      :position "absolute"
;;      :top "80px"
;;      :right 0
;;      :width "100%"
;;      :background "black"
;;      :text-align "left"
;;      :padding "5px 10px"}))


;; (defn search-help-h4 []
;;   {:font-size "16px"
;;    :font-weight "bold"})


;; (defn search-help-td []
;;   {:width "50%"})
